import { actionsCreators } from 'store/common'

import { REDUCER_NAME_ME } from 'utils/constants/store/reducersNames'

const creatorSettings = {
  staticUrl: '',
  staticEntityKey: REDUCER_NAME_ME,
}

export const fetchData = actionsCreators.makeFetchStaticItem({
  ...creatorSettings,
  staticUrl: '/users/me',
})
